module.exports = __webpack_public_path__ + "static/media/shiyi_liu.5eadfeb7.png";